import useTrackedSurface from './useTrackedSurface'

export default function TrackSurface({ event, active = true, contentId, content, parent, dedupeMs = 0 }) {
    useTrackedSurface(event, { active, contentId, content, parent, dedupeMs })
    return null
}
